import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { ProSidebarProvider } from "react-pro-sidebar";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import {
  LanguageContextProvider,
  assertValidLanguage,
} from "./contexts/LanguageContext";
import { NavbarCommonSpaceProvider } from "./contexts/NavbarCommonSpace";
import { UserContextProvider } from "./contexts/UserContext";
import { UserRegistraionContextProvider } from "./contexts/UserRegistrationContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { cookieUtils } from "./utils/cookieUtils";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: { retry: false },
  },
});

// let user = JSON.parse(localStorage.userDetails || null);
// let userDetails = JSON.parse(localStorage.userRegestrationDetails || null);

// if (!user?.name || !user?.role) user = null;

// let defaultLang = localStorage.defaultLang;

let user = cookieUtils.getSecureCookie('userDetails');
const userDetails = cookieUtils.getSecureCookie('userRegestrationDetails');

if (!user?.name || !user?.role) user = null;

let defaultLang = cookieUtils.getSecureCookie('defaultLang');

if (!assertValidLanguage(defaultLang)) {
  defaultLang = "english";
}

root.render(
  <React.StrictMode>
    <LanguageContextProvider defaultValue={defaultLang}>
      <UserContextProvider defaultValue={user}>
        <UserRegistraionContextProvider defaultValue={userDetails}>
          <NavbarCommonSpaceProvider>
            <QueryClientProvider client={qc}>
              <ProSidebarProvider>
                <BrowserRouter>
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    draggable
                    pauseOnHover
                  />
                  <App />
                </BrowserRouter>
              </ProSidebarProvider>
            </QueryClientProvider>
          </NavbarCommonSpaceProvider>
        </UserRegistraionContextProvider>
      </UserContextProvider>
    </LanguageContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
